import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query} from 'react-apollo'
import 'react-table/react-table.css'
import numeral from 'numeral'
import {withRouter} from 'react-router-dom'

import AUSelectGenerator from '../auto_updaters/Select'
import QUERY from '../../../queries/fee_drawdown_report'

const AUSelectProjectStatuses = AUSelectGenerator('project_statuses', 'project_status_id description', 'project_status_id', ['description'])
const AUSelectUsers = AUSelectGenerator('users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])



const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

class Table extends Component {

    render() {
        return (<ReactTable
            data={this.props.projects}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "Project ID",
                    id: 'project_id',
                    accessor: d => `${d.project_id}`,
                    filterMethod: (filter, row) => {
                        if(filter){
                            return row.project_id.toLowerCase().includes(filter.value.toLowerCase())
                        }
                        return true
                    },
                },
                {
                    Header: "Name",
                    id: 'name',
                    accessor: 'name',
                    filterMethod: (filter, row) => {
                        if(filter){
                            return row.name.toLowerCase().includes(filter.value.toLowerCase())
                        }
                        return true
                    },
                },
                {
                    Header: "Status",
                    id: 'project_status_id',
                    accessor: "project_status.description",
                    filterMethod: (filter, row) => {
                        if(filter){
                            return row._original.project_status.project_status_id === parseInt(filter.value)
                        }
                        return true
                    },
                    Filter: ({filter, onChange}) => {
                        console.log(filter)
                        return <AUSelectProjectStatuses className="form-control-sm" value={(filter) ? filter.value : ''} onChange={onChange}/>
                    },
                    
                },
                {
                    Header: "Clients",
                    accessor: "clients",
                    Cell: row => (
                        <div>
                            {row.value.map(({name}) => <div>{name}</div>)}
                        </div>
                    ),
                    filterMethod: (filter, row) => {
                        if(filter){
                            const {_original: {clients}} = row
                            const clientsStr = (clients && clients.length) ? clients.map(({name}) => name).join(' ') : null
                            return clientsStr && clientsStr.toLowerCase().includes(filter.value.toLowerCase())
                        }
                        return true
                    },
                },
                {
                    Header: "Director",
                    id: 'project_director_id',
                    accessor: ({project_director}) => project_director && `${project_director.first_name} ${project_director.last_name}`,
                    filterMethod: (filter, row) => {
                        if(filter){
                            return row._original.project_director && row._original.project_director.user_id === parseInt(filter.value)
                        }
                        return true
                    },
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUsers className="form-control-sm" value={(filter) ? filter.value : ''} onChange={onChange}/>
                    }
                },
                {
                    Header: "Lead Engineer",
                    id: 'project_manager_id',
                    accessor: ({project_manager}) => project_manager && `${project_manager.first_name} ${project_manager.last_name}`,
                    filterMethod: (filter, row) => {
                        if(filter){
                            return row._original.project_manager && row._original.project_manager.user_id === parseInt(filter.value)
                        }
                        return true
                    },
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUsers className="form-control-sm" value={(filter) ? filter.value : ''} onChange={onChange}/>
                    }
                },
                
                {
                    Header: "Total Budget",
                    id: 'total_budget',
                    accessor: ({total_budget}) => format(total_budget),
                    filterable: false
                },
                {
                    Header: "Total Expenditure",
                    id: 'total_fees',
                    accessor: ({total_fees, total_supplier_invoiced}) => format(total_fees + total_supplier_invoiced),
                    filterable: false
                },
                {
                    Header: "Amount to Invoice",
                    id: "amount_to_invoice",
                    accessor: ({amount_to_invoice}) => format(amount_to_invoice),
                    filterable: false
                }

            ]}
            className="-striped -highlight"
            filterable
            pageSize={100}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        this.props.history.push(`/reports/fee_drawdown/${rowInfo.original.project_id}`)
                    }
                }
            }}
        />)
    }
}

Table = withRouter(Table)

export default class FeeDrawdownTable extends Component {
    render() {
        return (<Query query={QUERY} fetchPolicy="network-only">
            {(result) => {

                const projects = (result.data && result.data.projects) ? result.data.projects : []

                return (
                    <Table loading={result.loading} projects={projects}/>

                )
            }}
        </Query>)
    }
}